import type { ReactChildren } from '@gokrew/models/ui.types';

export interface PermissionGuardBaseProps<T, U> extends ReactChildren {
  fallback?: React.ReactNode;
  scope?: T | T[];
  permissions: U;
}

export function PermissionGuardBase<T, U extends Set<unknown>>({
  children,
  permissions,
  scope = [],
  fallback = null,
}: PermissionGuardBaseProps<T, U>) {
  if (!Array.isArray(scope)) {
    scope = [scope];
  }

  if (scope.length === 0) return children;

  const hasPermission = scope.some((_scope) => permissions.has(_scope));

  if (!hasPermission) {
    return fallback;
  }

  return children;
}
